// Purpose: Keeps Tab and TabPanel keyboard focus visible in BayHive purple.
import { createInsetFocusRing } from '../shared.js';

export const navigationComponents = {
  tabs: {
    tab: {
      focusRing: createInsetFocusRing(),
    },
    tabpanel: {
      focusRing: createInsetFocusRing(),
    },
  },
};

export default navigationComponents;
